import { geoConfig } from './config';
import { createGoogleProvider } from './providers/google';
import { createOsmProvider } from './providers/osm';
import type { GeoProvider } from './types';

export type { GeoProvider, LatLng, LineString, PlaceSuggestion, ProviderRoute } from './types';

export const geoProvider: GeoProvider =
  geoConfig.provider === 'google'
    ? createGoogleProvider({ apiKey: geoConfig.googleApiKey })
    : createOsmProvider(geoConfig.osm);
